"use strict";

var _createForOfIteratorHelper = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _get = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/get");

var _getPrototypeOf = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _createSuper = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createSuper");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var _require = require("../helpers/strings"),
    stripAndCollapseASCIIWhitespace = _require.stripAndCollapseASCIIWhitespace;

var _require2 = require("../helpers/internal-constants"),
    domSymbolTree = _require2.domSymbolTree;

var _require3 = require("../helpers/traversal"),
    closest = _require3.closest;

var _require4 = require("../helpers/form-controls"),
    formOwner = _require4.formOwner;

var HTMLOptionElementImpl = /*#__PURE__*/function (_HTMLElementImpl) {
  _inherits(HTMLOptionElementImpl, _HTMLElementImpl);

  var _super = _createSuper(HTMLOptionElementImpl);

  function HTMLOptionElementImpl(args, privateData) {
    var _this;

    _classCallCheck(this, HTMLOptionElementImpl);

    _this = _super.call(this, args, privateData); // whenever selectedness is set to true, make sure all
    // other options set selectedness to false

    _this._selectedness = false;
    _this._dirtyness = false;
    return _this;
  }

  _createClass(HTMLOptionElementImpl, [{
    key: "_removeOtherSelectedness",
    value: function _removeOtherSelectedness() {
      // Remove the selectedness flag from all other options in this select
      var select = this._selectNode;

      if (select && !select.hasAttributeNS(null, "multiple")) {
        var _iterator = _createForOfIteratorHelper(select.options),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var option = _step.value;

            if (option !== this) {
              option._selectedness = false;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }, {
    key: "_askForAReset",
    value: function _askForAReset() {
      var select = this._selectNode;

      if (select) {
        select._askedForAReset();
      }
    }
  }, {
    key: "_attrModified",
    value: function _attrModified(name) {
      if (!this._dirtyness && name === "selected") {
        this._selectedness = this.hasAttributeNS(null, "selected");

        if (this._selectedness) {
          this._removeOtherSelectedness();
        }

        this._askForAReset();
      }

      _get(_getPrototypeOf(HTMLOptionElementImpl.prototype), "_attrModified", this).apply(this, arguments);
    }
  }, {
    key: "_selectNode",
    get: function get() {
      var select = domSymbolTree.parent(this);

      if (!select) {
        return null;
      }

      if (select.nodeName.toUpperCase() !== "SELECT") {
        select = domSymbolTree.parent(select);

        if (!select || select.nodeName.toUpperCase() !== "SELECT") {
          return null;
        }
      }

      return select;
    }
  }, {
    key: "form",
    get: function get() {
      return formOwner(this);
    }
  }, {
    key: "text",
    get: function get() {
      // TODO is not correctly excluding script and SVG script descendants
      return stripAndCollapseASCIIWhitespace(this.textContent);
    },
    set: function set(value) {
      this.textContent = value;
    }
  }, {
    key: "value",
    get: function get() {
      if (this.hasAttributeNS(null, "value")) {
        return this.getAttributeNS(null, "value");
      }

      return this.text;
    },
    set: function set(value) {
      this.setAttributeNS(null, "value", value);
    }
  }, {
    key: "index",
    get: function get() {
      var select = closest(this, "select");

      if (select === null) {
        return 0;
      }

      return select.options.indexOf(this);
    }
  }, {
    key: "selected",
    get: function get() {
      return this._selectedness;
    },
    set: function set(s) {
      this._dirtyness = true;
      this._selectedness = Boolean(s);

      if (this._selectedness) {
        this._removeOtherSelectedness();
      }

      this._askForAReset();

      this._modified();
    }
  }, {
    key: "label",
    get: function get() {
      if (this.hasAttributeNS(null, "label")) {
        return this.getAttributeNS(null, "label");
      }

      return this.text;
    },
    set: function set(value) {
      this.setAttributeNS(null, "label", value);
    }
  }]);

  return HTMLOptionElementImpl;
}(HTMLElementImpl);

module.exports = {
  implementation: HTMLOptionElementImpl
};